import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { EventParticipantStatusEnum } from 'src/shared/models/enums/eventParticipantStatus.enum';
import { ToggleButton } from '@mui/material';
import { EventParticipant } from '../models/eventParticipant';

type EventParticipantFilterProps = {
  participants: EventParticipant[];
  callback: (val: EventParticipantStatusEnum[]) => void;
};

export const EventParticipantFilter = (props: EventParticipantFilterProps) => {
  const { participants, callback } = props;
  const { t } = useTranslation();

  const [selectedKeys, setSelectedKeys] = useState<EventParticipantStatusEnum[]>();
  const [eventParticipantStatuses, setEventParticipantStatuses] = useState<EventParticipantStatusEnum[]>();

  const handleKeys = (event: React.MouseEvent<HTMLElement>, newKeys: EventParticipantStatusEnum[]) => {
    callback(newKeys);
    setSelectedKeys(newKeys);
  };

  useEffect(() => {
    if (participants) {
      const uniqueStatuses = participants.map((item) => item.status).filter((value, index, self) => self.indexOf(value) === index);
      setEventParticipantStatuses(uniqueStatuses);
    }
  }, [participants]);

  const getStatusLabel = (status) => {
    if (status === EventParticipantStatusEnum.Attending) return t('event:participantStatuses.attending');
    if (status === EventParticipantStatusEnum.NotAttending) return t('event:participantStatuses.notAttending');
    if (status === EventParticipantStatusEnum.Cancelled) return t('event:participantStatuses.cancelled');
    return t('event:participantStatuses.unanswered');
  };

  return (
    <FormFieldset legend={t('event:participantStatus')} noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {eventParticipantStatuses &&
          eventParticipantStatuses.map((x) => (
            <ToggleButton value={x} key={x}>
              {getStatusLabel(x)}
            </ToggleButton>
          ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
